<template>
  <div class="c-config-content">
    <div class="c-template-table table-responsive c-role-table c-draggable-table">
      <table class="table table-hover">
        <thead>
        <tr>
          <th>{{ $t('label') }}</th>
          <th>{{ $t('inputType') }}</th>
          <th>{{ $t('equivalentField') }}</th>
          <th class="td-three-btn text-right">
            <button class="btn btn-success btn-sm" @click="create()" v-if="!campaign.startTime && updatePermission && !(campaign.type === 'zns' || (campaign.isAgainTwo && campaign.typeTwo === 'zns') || (campaign.isAgainThree && campaign.typeThree === 'zns'))">
              <i class="icon12-add-white icon-left"></i>{{ $t('create') }}
            </button>
          </th>
        </tr>
        </thead>
        <tbody>
        <tr>
          <td>{{ $t('name') }} <span class="text-gray-999 small">name</span></td>
          <td>{{ $t('text') }}</td>
          <td>{{ $t('customerName') }}</td>
          <td></td>
        </tr>
        <tr>
          <td>{{ $t('phone') }} <span class="text-gray-999 small">phone</span></td>
          <td>{{ $t('text') }}</td>
          <td>{{ $t('phone') }}</td>
          <td></td>
        </tr>
        <tr>
          <td>{{ $t('desc') }} <span class="text-gray-999 small">desc</span></td>
          <td>{{ $t('text') }}</td>
          <td>{{ $t('desc') }}</td>
          <td></td>
        </tr>
        </tbody>
        <draggable v-if="!isEmpty" v-model="campaign.contactCustomFields" tag="tbody">
          <tr v-for="item in campaign.contactCustomFields" :key="item.key" class="tr-draggable">
            <td>{{ item.label }} <span class="text-gray-999 small">{{item.key}}</span></td>
            <td>{{ $t(item.inputType) }}</td>
            <template>
              <td v-if="item.refKey">{{ getEquivalentField(item.refKey) }}</td>
              <td v-else class="text-gray-999 small">{{ $t('notUpdated') }}</td>
            </template>
            <td class="text-right">
              <button @click="update(item.key)" v-b-tooltip="$t('detail')"
                      class="btn btn-outline-gray btn-sm is-border-1" type="button">
                <font-awesome-icon icon="info"></font-awesome-icon>
              </button>
            </td>
          </tr>
        </draggable>
      </table>
    </div>
    <b-modal v-model="showForm" :title="$t('detail')" no-close-on-backdrop no-enforce-focus>
      <form-input :disabled="true" :label="$t('label')" :model="formModel" attribute="label" :errors="formErrors"></form-input>
      <form-input :disabled="true" :label="$t('key')" :model="formModel" attribute="key" :errors="formErrors"></form-input>
      <form-select :disabled="true" :label="$t('inputType')" :model="formModel" attribute="inputType" :errors="formErrors" :options="inputTypeOptions"></form-select>
      <form-array :disabled="true" v-if="formModel.inputType === 'multiple' || formModel.inputType === 'one'" :label="$t('inputOptions')" :model="formModel" attribute="inputOptions" :errors="formErrors"></form-array>
      <form-input :disabled="true" :label="$t('refKey')" :model="formModel" attribute="refKey" :errors="formErrors" :options="refOptions"></form-input>
      <form-checkbox-group :disabled="true" v-if='formModel.isOutputData' :model="formModel" attribute="requiredOnStatus" errors="formErrors" :label="$t('requiredOnStatus')" :options="requiredOnStatusOption"></form-checkbox-group>
      <template v-slot:modal-footer>
        <b-button variant="secondary" class="float-right" @click="showForm = false">{{ $t('close') }}</b-button>
      </template>
    </b-modal>
  </div>
</template>

<script>
import _ from 'lodash';
import draggable from 'vuedraggable';
import crud from '@/mixins/CRUD';
import list from '@/mixins/List';

export default {
  props: ["campaign", "title", "updatePermission"],
  mixins: [crud, list],
  components: {draggable},
  data: function () {
    return {
      service: '/message-campaign',
      showList: false,
      listTitle: null,
      defaultFormModel: {
        label: '',
        key: '',
        inputType: 'text',
        inputOptions: null,
        position: 1,
        requiredOnStatus: [],
        refKey: null
      },
      inputTypeOptions: [
        {value: 'text', text: this.$t('text')},
        {value: 'number', text: this.$t('number')},
        {value: 'date', text: this.$t('date')},
        {value: 'one', text: this.$t('one')},
        {value: 'multiple', text: this.$t('multiple')},
      ],
      requiredOnStatusOption: [
        {value: 'ok', text: this.$t('ok')},
        {value: 'deny', text: this.$t('deny')},
        {value: 'callback', text: this.$t('callback')},
        {value: 'failed', text: this.$t('failed')},
      ],
      isEmpty: false,
      refOptions: [
        {value: null, text: this.$t('chooseField')},
        {value: 'customerName', text: this.$t('customerName')},
        {value: 'opportunityName', text: this.$t('opportunityName')},
        {value: 'email', text: this.$t('email')},
        {value: 'gender', text: this.$t('gender')},
        {value: 'dob', text: this.$t('dob')},
        {value: 'company', text: this.$t('company')},
        {value: 'title', text: this.$t('title')},
        {value: 'department', text: this.$t('department')},
        {value: 'address', text: this.$t('address')},
        {value: 'website', text: this.$t('website')},
        {value: 'facebookName', text: this.$t('facebookName')},
        {value: 'facebookId', text: this.$t('facebookId')},
        {value: 'zaloName', text: this.$t('zaloName')},
        {value: 'zaloId', text: this.$t('zaloId')},
      ]
    }
  },
  watch: {
    "formModel.label": {
      handler(val) {
        if (!this.formModel.id) {
          this.formModel.key = this.$utils.createAlias(val);
        }
      }
    },
    "formModel.refKey": function (val) {
      if (val) {
        this.formModel.refKey = this.getEquivalentField(val);
      }
    }
  },
  methods: {
    load: function () {
      let loadingDelay = _.delay(() => {
        this.listLoading = true;
      }, 250);
      this.$store.state.customerCustomFields.forEach(c => {
        if (!this.refOptions.find(o => o.value === c.key)) {
          this.refOptions.push({value: c.key, text: c.label});
        }
      });
      this.isEmpty = true;
      let cf = this.campaign.contactCustomFields.find(item => {
        return item.isOutputData === this.isOutputData;
      });
      if (typeof (cf) !== 'undefined') {
        this.isEmpty = false;
      }
      clearTimeout(loadingDelay)
    },
    update: function (key) {
      this.formModel = {};
      this.formTitle = this.$t('update');
      this.formErrors = [];
      this.showForm = true;
      this.formModel = this.campaign.contactCustomFields.find(item => {
        return item.key === key;
      });
      this.formModel.id = key;
    },
    getEquivalentField(key) {
      let label = this.refOptions.find(f => f.value === key);
      if (label) {
        return label.text;
      } else {
        return key;
      }
    },
  },
  i18n: {
    messages: {
      vi: {
        label: "Tên trường dữ liệu",
        inputType: "Kiểu nhập liệu",
        equivalentField: "Trường thông tin tương ứng",
        contactName: "Tên liên hệ",
        result: "Kết quả",
        retryTime: "Thời gian hẹn gọi lại",
        number: "Nhập số",
        one: "Chọn một",
        text: "Nhập chữ",
        customerName: "Tên khách hàng",
        opportunityName: "Tên cơ hội bán hàng",
        email: "Email",
        company: "Công ty",
        title: "Chức danh",
        department: "Phòng ban",
        website: "Website",
        na: "Không có",
        requiredStatuses: "Bắt buộc nhập nếu cuộc gọi có kết quả là",
        ok: "Đồng ý",
        deny: "Từ chối",
        callback: "Hẹn gọi lại",
        failed: "Thất bại",
        notRequired: "Không bắt buộc nhập",
        key: "Mã",
        inputOptions: "Danh sách lựa chọn",
        date: "Thời gian",
        multiple: "Chọn nhiều",
        refKey: "Trường thông tin tương ứng của khách hàng",
        chooseField: "Chọn trường",
        address: "Địa chỉ",
        close: "Đóng" ,
      },
      en: {
        label: "Tên trường dữ liệu",
        inputType: "Kiểu nhập liệu",
        equivalentField: "Trường thông tin tương ứng",
        contactName: "Tên liên hệ",
        result: "Kết quả",
        retryTime: "Thời gian hẹn gọi lại",
        number: "Nhập số",
        one: "Chọn một",
        text: "Nhập chữ",
        customerName: "Tên khách hàng",
        opportunityName: "Tên cơ hội bán hàng",
        email: "Email",
        company: "Công ty",
        title: "Chức danh",
        department: "Phòng ban",
        website: "Website",
        na: "Không có",
        requiredStatuses: "Bắt buộc nhập nếu cuộc gọi có kết quả là",
        ok: "Đồng ý",
        deny: "Từ chối",
        callback: "Hẹn gọi lại",
        failed: "Thất bại",
        notRequired: "Không bắt buộc nhập",
        key: "Mã",
        inputOptions: "Danh sách lựa chọn",
        date: "Thời gian",
        multiple: "Chọn nhiều",
        refKey: "Trường thông tin tương ứng của khách hàng",
        chooseField: "Chọn trường",
        address: "Địa chỉ",
        close: "Đóng" ,
      }
    }
  }
};
</script>
<style>
.text-gray-999 {
  color: #999;
}
</style>
